$(document).on "turbolinks:load", ->

  $('#confirm-delete, #confirm-leave').on('show.bs.modal', (e) ->
    $(this).find('.modal-confirm-submit').attr('href', $(e.relatedTarget).data('href'))
    $(this).find('.modal-confirm-submit').attr('data-method', 'delete')
  )

  $('#confirm-unlink-lti-line-items').on('show.bs.modal', (e) ->
    $(this).find('.modal-confirm-submit').attr('href', $(e.relatedTarget).data('href'))
    $(this).find('.modal-confirm-submit').attr('data-method', 'get')
  )

  $('#confirm-unlink-course').on('show.bs.modal', (e) ->
    $(this).find('.modal-confirm-submit').attr('href', $(e.relatedTarget).data('href'))
    $(this).find('.modal-confirm-submit').attr('data-method', 'put')
  )

  # Populate confirmation popup with selected CW course name
  $('#confirm-link').on('show.bs.modal', (e) ->
    $('#cw-course-name').text($('#course_id option:selected').text())
    $('#cw-course-name').text($('#record-name').val())
  )